import { Ref, forwardRef } from "react"

import { LabelColor } from "@/v2/graphql/public-generated-rq"
import { twMerge } from "@lumen-energy/config-tailwind/twMerge"
import { Tag, TagProps } from "@lumen-energy/design-system"
import { IconPlus } from "@tabler/icons-react"

import { LabelThemeColors } from "./LabelGroup"

export interface LabelProps {
  pid: string
  name: string
  themeColor: LabelColor
}

type LabelTagProps = Omit<TagProps, "label"> & LabelProps

export const Label = forwardRef<HTMLSpanElement, LabelTagProps>(function Label(
  { name, themeColor = LabelColor.Success, className = "", ...props }: LabelTagProps,
  ref: Ref<HTMLSpanElement>,
) {
  return (
    <Tag
      className={twMerge("cursor-pointer whitespace-pre", className)}
      label={name}
      size="small"
      variant={LabelThemeColors[themeColor]}
      ref={ref}
      {...props}
    />
  )
})

export interface LabelAppProps {
  className?: string
}

export const LabelAdd = forwardRef<HTMLSpanElement, LabelAppProps>(function LabelAdd(
  { className, ...props },
  ref: Ref<HTMLSpanElement>,
) {
  return (
    <Tag
      className={twMerge(
        "cursor-pointer whitespace-pre bg-white text-grey-500 hover:text-grey-700 aria-expanded:bg-grey-300 print:hidden",
        className,
      )}
      label={"Add label"}
      variant="neutral"
      iconPosition="left"
      icon={IconPlus}
      ref={ref}
      {...props}
    />
  )
})
